"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_common_strings_1 = require("owa-strings/owa-common-strings");
var datapoints_1 = require("./datapoints");
var deleteItemsStoreUpdate_1 = require("owa-mail-actions/lib/triage/deleteItemsStoreUpdate");
var getItem_1 = require("owa-mail-store/lib/services/getItem");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var itemResponseShape_1 = require("owa-service/lib/factory/itemResponseShape");
var reportMessageToSafetyLibraryService_1 = require("../services/reportMessageToSafetyLibraryService");
var Store_1 = require("owa-mail-store/lib/store/Store");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_confirm_dialog_1 = require("owa-confirm-dialog");
var owa_strings_1 = require("owa-strings");
var owa_service_error_1 = require("owa-service-error");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var UnsubscribeEmailActionName = 'unsubscribeEmail';
// The regular expression of message header of a trusted sender
var TRUSTED_MESSAGE_HEAD_REGX = new RegExp('List-Unsubscribe:[ ]+<mailto:');
/**
 * Perform the unsubscribe action without the confirmation dialog
 * @param message the message
 * @param originalTableView the table view that message belongs to
 * @param isTrustedUnsubscribe whether to set actionData for trusted unsubscribe
 * @param actionSource the user source that initated the action
 */
var unsubscribeWithoutConfirmDialog = legacy_1.action('unsubscribeWithoutConfirmDialog', datapoints_1.default.unsubscribeDatapoint)(function unsubscribeWithoutConfirmDialog(message, originalTableView, isTrustedUnsubscribe, actionSource) {
    // TODO: VSO 11909: Handle undo for destructive mail actions
    var actionResponse = owa_service_error_1.handleServiceError(UnsubscribeEmailActionName, owa_mail_strings_1.default.errorUnsubscribe, function () {
        return reportMessageToSafetyLibraryService_1.default([message.ItemId.Id], 5 /* Unsubscribe */, isTrustedUnsubscribe ? [1] : undefined);
    }, function (isSuccessful) {
        return { isSuccessful: isSuccessful };
    });
    var itemContext = {
        itemId: message.ItemId.Id,
        conversationId: message.ConversationId.Id,
        isRead: message.IsRead,
    };
    deleteItemsStoreUpdate_1.default([itemContext], message.ParentFolderId.Id);
    return actionResponse;
});
/**
 * Show the unsubscribe confirmation dialog
 * @param message the message
 * @param originalTableView the table view
 * @param isTrustedUnsubscribe whether to perform the trusted unsubscribe
 * @param actionSource the user source that initated the action
 * @return a Promise when the action completes
 */
var showUnsubscribeDialog = legacy_1.action('showUnsubscribeDialog')(function showUnsubscribeDialog(message, originalTableView, isTrustedUnsubscribe, actionSource) {
    var _this = this;
    return owa_confirm_dialog_1.confirm(owa_mail_strings_1.default.unsubscribeDialogTitleText, owa_strings_1.format(owa_mail_strings_1.default.unsubscribeDialogSubTitleText, message.From.Mailbox.Name), false /* resolevImmediately */, {
        okText: owa_mail_strings_1.default.unsubscribe,
        cancelText: owa_common_strings_1.default.cancelButton,
    }).then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            if (response === 0 /* ok */) {
                return [2 /*return*/, unsubscribeWithoutConfirmDialog(message, originalTableView, isTrustedUnsubscribe, actionSource)];
            }
            return [2 /*return*/];
        });
    }); });
});
/**
 * Perform the unsubscribe action with the confirmation dialog
 * @param itemId the item id
 * @param tableViewId the table view id
 * @param actionSource the user source that initated the action
 * @param state the state which contains the tableView and reportToExternalSender in user configuration
 */
exports.default = legacy_1.select({
    message: function (itemId, tableViewId) { return Store_1.default.items.get(itemId); },
    originalTableView: function (itemId, tableViewId) {
        return owa_mail_list_store_1.listViewStore.tableViews.get(tableViewId);
    },
    reportToExternalSender: function () { return getUserConfiguration_1.default().SafetyUserOptions.ReportToExternalSender; },
})(legacy_1.action(UnsubscribeEmailActionName)(function unsubscribeEmail(itemId, tableViewId, actionSource, state) {
    var message = state.message, originalTableView = state.originalTableView, reportToExternalSender = state.reportToExternalSender;
    var isMessageLevelSafeOrTrusted = message.MessageSafety &&
        (message.MessageSafety.MessageSafetyLevel == 2 /* Safe */ ||
            message.MessageSafety.MessageSafetyLevel == 1 /* Trusted */);
    if (!reportToExternalSender || !isMessageLevelSafeOrTrusted) {
        // Show confirmation dialog for untrusted sender unsubscribe if reportToExternalSender is not enabled,
        // or the MessageSafetyLevel isn't Safe or Trusted
        return showUnsubscribeDialog(message, originalTableView, false /* isTrustedUnsubscribe */, actionSource);
    }
    var itemShape = itemResponseShape_1.default({
        BaseShape: 'IdOnly',
    });
    // We need to get the headers for this message to test
    // for the List-Unsubscribe before performing a trusted unsubscribe
    return getItem_1.default([message.ItemId.Id], itemShape, 'MessageDetails').then(function (response) {
        if (response[0].ResponseClass == 'Success') {
            var responseItem = response[0];
            var messageHeader = responseItem.Items[0].ExtendedProperty &&
                responseItem.Items[0].ExtendedProperty[0].Value;
            return showUnsubscribeDialog(message, originalTableView, TRUSTED_MESSAGE_HEAD_REGX.test(messageHeader) /* isTrustedUnsubscribe */, actionSource);
        }
        else {
            throw new Error(response[0].MessageText);
        }
    });
}));
//# sourceMappingURL=unsubscribeEmail.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/unsubscribeEmail.js
// module id = 5634
// module chunks = 62